import React from "react";
import FormattedDate from "./FormattedDate.js";
import WeatherIcon from "./WeatherIcon.js";
import WeatherTemperature from "./WeatherTemperature.js";
import "./WeatherInfo.css";

export default function WeatherInfo(props) {
  return (
    <div className="weatherinfo">
      <h1 className="text-capitalize">{props.data.city}</h1>
      <ul>
        <li className="currentdate">
          <FormattedDate date={props.data.date} />
        </li>
        <li className="weatherdescription">{props.data.description}</li>
      </ul>
      <div className="row pb-3">
        <div className="col-6 d-inline-flex mt-3 ps-3">
          <WeatherIcon code={props.data.icon} size={70} />
          <WeatherTemperature celsius={props.data.temperature} />
        </div>
        <div className="col-6 mt-3">
          <ul>
            <li className="humidity">
              Humidity: {Math.round(props.data.humidity)}%
            </li>
            <li className="wind">Wind: {Math.round(props.data.wind)} km/h</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
